import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { MANUAL_VOUCHER_PAYMENT_PATH } from '../../../../config/paths';
import ManualVoucherPaymentDeleteButton from './ManualVoucherPaymentDeleteButton';

const ManualVoucherPaymentToolbar = ({ manualVoucherPaymentId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${MANUAL_VOUCHER_PAYMENT_PATH}/${manualVoucherPaymentId}/edit`}
      />{' '}
      <ManualVoucherPaymentDeleteButton
        manualVoucherPaymentId={manualVoucherPaymentId}
      />
    </div>
  </ButtonToolbar>
);

ManualVoucherPaymentToolbar.propTypes = {
  manualVoucherPaymentId: PropTypes.number.isRequired,
};

export default ManualVoucherPaymentToolbar;
